import styled from '@emotion/styled'

export const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`

export const HeaderRow = styled.div`
  margin: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const HeaderLogo = styled.img`
  width: 220px;
  height: 50px;
`

export const HeaderLogoutContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  color: ${props => props.theme.colors.semiTranpBlack};
  cursor: pointer;
`

export const HeaderNavLinks = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${props => props.theme.colors.lightGray};
  border-bottom: 1px solid ${props => props.theme.colors.lightGray};
  margin-top: 10px;
  padding: 3px 20px;
`

export const HeaderNavLinksRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 14px;
  color: ${props => props.theme.colors.semiTranpBlack};

  a {
    text-decoration: none;
    color: inherit;
  }
  cursor: pointer;
  ${props =>
    props.isActive &&
    `
    color: ${props.theme.colors.primary};
    font-weight: 500;
  `}
`

export const NavLinkLeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5rem;
  cursor: pointer;
`

export const HeaderBannerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 1100;
  pointer-events: none;
`
